import { request } from '@/util/http'

export const getUser = (id) => {
  return request({
    url: '/health/userjk/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const getList = (current, size, params) => {
  return request({
    url: '/health/device/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/health/device/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/device/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/device/submit',
    method: 'post',
    data: row
  })
}

